export var MediaPopupMode;
(function(MediaPopupMode) {
    MediaPopupMode["MANAGER"] = "manager";
    MediaPopupMode["SELECTOR"] = "selector";
})(MediaPopupMode || (MediaPopupMode = {}));
export var MediaSourceType;
(function(MediaSourceType) {
    MediaSourceType["GALLERY"] = "gallery";
    MediaSourceType["COLLECTION"] = "collection";
    MediaSourceType["PRIVATE_COLLECTION"] = "private_collection";
    MediaSourceType["STASH"] = "stash";
    MediaSourceType["BROWSE"] = "browse";
    MediaSourceType["CUSTOM_SET"] = "custom_set";
    MediaSourceType["JOURNAL"] = "journal";
    MediaSourceType["STATUS"] = "status";
    MediaSourceType["POLL"] = "poll";
    MediaSourceType["POSTS"] = "posts";
    MediaSourceType["TIER"] = "tier";
    MediaSourceType["TIER_DEVIATIONS"] = "tier_deviations";
    MediaSourceType["TIER_POSTS"] = "tier_posts";
    MediaSourceType["COMMISSIONS"] = "commissions";
})(MediaSourceType || (MediaSourceType = {}));
export var NotificationType;
(function(NotificationType) {
    NotificationType["LABEL_AS"] = "LABEL_AS";
})(NotificationType || (NotificationType = {}));

//# sourceMappingURL=types.js.map